import React, { useState } from 'react';
import { useCredits } from '../../../hooks/useCredits';
import UpgradeModal from './UpgradeModal';
import './FeatureGate.scss';

const FeatureGate = ({
  children,
  operation,
  creditsRequired = null,
  showCreditCost = true,
  requireSubscription = false,
  minimumTier = null,
}) => {
  const { balance, subscriptionTier, checkCredits } = useCredits();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const cost = creditsRequired || (operation && require('../../../hooks/useCredits').CreditCosts[operation]) || 1;
  const hasCredits = checkCredits(operation, cost);

  const tierHierarchy = {
    FREE: 0,
    STARTER: 1,
    PRO: 2,
    PREMIUM: 3,
  };

  const meetsMinimumTier = !minimumTier || tierHierarchy[subscriptionTier] >= tierHierarchy[minimumTier];

  const canAccess = hasCredits && meetsMinimumTier;

  const handleClick = originalOnClick => {
    return e => {
      if (!canAccess) {
        e.preventDefault();
        e.stopPropagation();
        setShowUpgradeModal(true);
        return;
      }

      if (originalOnClick) {
        originalOnClick(e);
      }
    };
  };

  // Clone children and wrap with gate logic
  const gatedChildren = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return child;

    const childProps = {
      ...child.props,
      onClick: handleClick(child.props.onClick),
      disabled: !canAccess || child.props.disabled,
      className: `${child.props.className || ''} ${!canAccess ? 'feature-gated' : ''}`.trim(),
    };

    return React.cloneElement(child, childProps);
  });

  return (
    <>
      <div className='feature-gate'>{gatedChildren}</div>

      {showUpgradeModal && (
        <UpgradeModal
          isOpen={showUpgradeModal}
          onClose={() => setShowUpgradeModal(false)}
          highlightedFeature={operation}
          requiredCredits={cost}
          currentBalance={balance}
          currentTier={subscriptionTier}
        />
      )}
    </>
  );
};

export default FeatureGate;
